// extracted by mini-css-extract-plugin
module.exports = {"superscript":"Superscript-module--superscript--3DKHF"};